import { resolveZoomConfig } from '../lib/zoomConfig';

/**
 * Slim status strip shown only when a non-prod Zoom (region, entryId) override
 * is active. Gated by `VITE_ZOOM_OVERRIDE_ENABLED` so the entire component is
 * dead-code-eliminated from prod bundles.
 */
export default function ZoomOverrideBanner() {
  if (!import.meta.env.VITE_ZOOM_OVERRIDE_ENABLED) return null;

  const cfg = resolveZoomConfig();
  if (!cfg.overrideActive) return null;

  return (
    <div
      role="status"
      className="bg-amber-600 text-white text-sm font-semibold"
      data-testid="zoom-override-banner"
    >
      <div className="mx-auto max-w-220 px-4 lg:px-6 py-1.5">
        TEST — Zoom override active (region={cfg.region}, entryId={cfg.entryId})
      </div>
    </div>
  );
}
